/* BJ: keep the Lasio launcher pinned mid-right, and get it OUT OF THE WAY when the chat is open. */
(function(){
  function panelOpen(){
    var o = document.getElementById('ai-chat-widget-container-inner');
    return o && getComputedStyle(o).display !== 'none';
  }
  function pin(){
    var b = document.getElementById('ai-chat-widget-button');
    if (!b) return;
    if (panelOpen()){ b.style.setProperty('display','none','important'); return; } /* hide the tab while chatting */
    if (b.style.display === 'none') b.style.removeProperty('display');
    if (!b.classList.contains('lassio-launcher-bar')) return;
    var cs = getComputedStyle(b);
    /* only rewrite when it has actually drifted, to avoid jitter */
    if (window.innerWidth <= 640){ /* phones: round icon bottom right (26 Sep 2026), the CSS in bj-overrides.css does the rest */
      if (cs.position === 'fixed' && (window.innerHeight - b.getBoundingClientRect().bottom) > 60 && (window.innerWidth - b.getBoundingClientRect().right) < 20) return;
      b.style.setProperty('position','fixed','important'); b.style.setProperty('top','auto','important'); b.style.setProperty('bottom','74px','important');
      b.style.setProperty('right','12px','important'); b.style.setProperty('left','auto','important'); b.style.setProperty('transform','translateZ(0)','important'); b.style.setProperty('transition','none','important');
      return;
    }
    if (cs.position === 'fixed' && Math.abs(b.getBoundingClientRect().top + b.offsetHeight/2 - window.innerHeight/2) < 2 && (window.innerWidth - b.getBoundingClientRect().right) < 10) return;
    b.style.setProperty('position','fixed','important');
    b.style.setProperty('top','50%','important');
    b.style.setProperty('bottom','auto','important');
    b.style.setProperty('right','6px','important');
    b.style.setProperty('left','auto','important');
    b.style.setProperty('transform','translateY(-50%) translateZ(0)','important');
    b.style.setProperty('transition','none','important');
  }
  var scheduled=false;
  function onScroll(){ if(scheduled)return; scheduled=true; requestAnimationFrame(function(){ scheduled=false; pin(); }); }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', pin);
  if (window.visualViewport){ window.visualViewport.addEventListener('scroll', onScroll); window.visualViewport.addEventListener('resize', pin); }
  try { new MutationObserver(function(){ pin(); }).observe(document.body, {subtree:true, attributes:true, attributeFilter:['style','class']}); } catch(e){}
  setInterval(pin, 500);
  document.addEventListener('DOMContentLoaded', pin); pin();
})();
